import { render, staticRenderFns } from "./DownloadTableData.vue?vue&type=template&id=0150d95a&"
import script from "./DownloadTableData.vue?vue&type=script&lang=js&"
export * from "./DownloadTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports